/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import Api from 'services/api';
import { StatesTypes } from 'store/modules/online_search_store/types';
import { States } from 'services/states';
import SquareLoader from '../square_loader';
import { Container } from './styles';

interface EditFilterModalProps {
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  showEditModal: boolean;
  dataFilter: any;
  users_filter: Array<string>;
}

const EditFilterModal = (props: EditFilterModalProps) => {
  const { setShowEditModal, showEditModal, dataFilter, users_filter } = props;
  const [obsFollowups, setObsFollowups] = useState<string>('');
  const [obsBidding, setObsBidding] = useState<string>('');
  const [title, setTitle] = useState<string>(dataFilter?.nome_filtro);
  const [users, setUsers] = useState<Array<any>>([]);
  const [statesBidding, setStatesBidding] = useState<Array<StatesTypes>>([]);
  const [citiesBidding, setCitiesBidding] = useState<string>(
    dataFilter?.licitacao[2]?.cidades?.values,
  );
  const [citiesFollowups, setCitiesFollowups] = useState<string>(
    dataFilter?.acompanhamento[2]?.cidades?.values,
  );
  const [statesFollowups, setStatesFollowups] = useState<Array<StatesTypes>>([]);
  const [loadingEdition, setLoadingEdition] = useState<boolean>(false);
  const [segmentosBidding, setSegmentosBidding] = useState<string>(
    dataFilter?.licitacao?.[0]?.atividades?.values,
  );
  const [segmentosFollowups, setSegmentosFollowups] = useState<string>(
    dataFilter?.acompanhamento?.[0]?.atividades?.values,
  );
  const [palavraChaveBidding, setPalavraChaveBidding] = useState<string>(
    dataFilter?.licitacao?.[2]?.palavra_chave?.values ||
      dataFilter?.licitacao?.[1]?.palavra_chave?.values,
  );
  const [palavraChaveFollowups, setPalavraChaveFollowups] = useState<string>(
    dataFilter?.acompanhamento?.[2]?.palavra_chave?.values ||
      dataFilter?.acompanhamento?.[1]?.palavra_chave?.values,
  );
  const [morning, setMorning] = useState<boolean>(dataFilter?.periodos?.manha);
  const [afternoon, setAfternoon] = useState<boolean>(dataFilter?.periodos?.tarde);
  const [night, setNight] = useState<boolean>(dataFilter?.periodos?.noite);

  const stateBidding = statesBidding?.map((statesBidding) => statesBidding.label);

  const stateFollowups = statesFollowups?.map((statesFollowups) => statesFollowups.label);

  const usersFilter = users?.map((users) => users.label);

  useEffect(() => {
    setUsers(
      dataFilter?.users.filter(Boolean).map((user: any) => {
        return { label: `${user.nome} (${user.email})`, value: user.nome };
      }),
    );
    setStatesBidding(
      dataFilter?.licitacao[1]?.estados?.values.map((state: any) => {
        return { label: `${state}`, value: state };
      }),
    );
    setStatesFollowups(
      dataFilter?.acompanhamento[1]?.estados?.values.map((state: any) => {
        return { label: `${state}`, value: state };
      }),
    );
    setObsFollowups('');

    dataFilter?.licitacao[2]?.cidades?.values
      ? setCitiesBidding(dataFilter?.licitacao[2]?.cidades?.values)
      : setCitiesBidding('');

    dataFilter?.acompanhamento[2]?.cidades?.values
      ? setCitiesFollowups(dataFilter?.acompanhamento[2]?.cidades?.values)
      : setCitiesFollowups('');

    dataFilter?.licitacao?.[2]?.palavra_chave?.values
      ? setPalavraChaveBidding(dataFilter?.licitacao?.[2]?.palavra_chave?.values)
      : setPalavraChaveBidding('');

    dataFilter?.licitacao?.[1]?.palavra_chave?.values
      ? setPalavraChaveBidding(dataFilter?.licitacao?.[1]?.palavra_chave?.values)
      : setPalavraChaveBidding('');

    dataFilter?.acompanhamento?.[2]?.palavra_chave?.values
      ? setPalavraChaveFollowups(dataFilter?.acompanhamento?.[2]?.palavra_chave?.values)
      : setPalavraChaveFollowups('');

    dataFilter?.acompanhamento?.[1]?.palavra_chave?.values
      ? setPalavraChaveFollowups(dataFilter?.acompanhamento?.[1]?.palavra_chave?.values)
      : setPalavraChaveFollowups('');

    dataFilter?.licitacao?.[0]?.atividades?.values
      ? setSegmentosBidding(dataFilter?.licitacao?.[0]?.atividades?.values)
      : setSegmentosBidding('');

    dataFilter?.acompanhamento?.[0]?.atividades?.values
      ? setSegmentosBidding(dataFilter?.acompanhamento?.[0]?.atividades?.values)
      : setSegmentosBidding('');

    setObsFollowups('');
    setObsBidding('');
    setTitle(dataFilter?.nome_filtro);
    setCitiesFollowups(dataFilter?.acompanhamento[2]?.cidades?.values);
  }, [dataFilter]);

  return (
    <Modal className="m-0" size="lg" show={showEditModal}>
      <Container>
        <div className="modal-header">
          <h5 className="modal-title">Solicitar edição de filtro</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={() => setShowEditModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <label htmlFor="title">Título:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    placeholder="Titulo"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Usuários</label>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <Select
                isMulti
                closeMenuOnSelect={false}
                name="users"
                options={users_filter.filter(Boolean).map((user: any) => {
                  return { label: `${user[0]} (${user[1]})`, value: user[0] };
                })}
                placeholder="Selecione os usuários"
                value={users || ''}
                classNamePrefix="select"
                className="basic-multi-select"
                onChange={(event) => setUsers([...event])}
              />
            </div>
          </div>
          <hr />
          <h4 className="font-weight-bold">Licitações</h4>
          <p className="mb-0">Período</p>
          <div className="row p-3 mt-0">
            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={morning}
                id="morning"
                onChange={(e) => setMorning(e.target.checked)}
              />
              <label className="form-check-labe mt-1" htmlFor="manha">
                Manhã
              </label>
            </div>
            <div className="col-md-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={afternoon}
                id="afternoon"
                onChange={(e) => setAfternoon(e.target.checked)}
              />
              <label className="form-check-label mt-1" htmlFor="manha">
                Tarde
              </label>
            </div>
            <div className="col-md-8">
              <input
                className="form-check-input"
                type="checkbox"
                checked={night}
                id="night"
                onChange={(e) => setNight(e.target.checked)}
              />
              <label className="form-check-label mt-1" htmlFor="manha">
                Noite
              </label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Segmentos</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Ex.: Gostaria de tudo relacionado a Painéis, luminosos, faixas, displays, plaqueta patrimonial"
              rows={3}
              value={segmentosBidding}
              onChange={(event) => setSegmentosBidding(event.target.value)}
            />
          </div>
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Estado</label>
            </div>
            <div className="float-right date-template">
              <button
                type="button"
                className="btn btn-sm btn-link pr-0"
                onClick={() => setStatesBidding(dataFilter?.licitacao[1]?.estados?.values)}
              >
                Todos os estados
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <Select
                isMulti
                name="estado"
                options={States}
                value={statesBidding || ''}
                closeMenuOnSelect={false}
                placeholder="Selecione um ou mais estados"
                classNamePrefix="select"
                className="basic-multi-select"
                onChange={(event) => setStatesBidding([...event])}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Cidades</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Descreva as cidades"
              rows={3}
              value={citiesBidding}
              onChange={(event) => setCitiesBidding(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Palavras-chave</label>
            <textarea
              className="form-control"
              id="palavra_chave"
              name="palavra_chave"
              placeholder="Ex.: Gostaria de tudo relacionado a Painéis, luminosos, faixas, displays, plaqueta patrimonial"
              rows={3}
              value={palavraChaveBidding}
              onChange={(event) => setPalavraChaveBidding(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Observações</label>
            <textarea
              className="form-control"
              id="observacao_bidding"
              name="observacao_bidding"
              placeholder="Escreva qualquer outra especificação para esse filtro"
              rows={3}
              value={obsBidding}
              onChange={(event) => setObsBidding(event.target.value)}
            />
          </div>
          <hr />

          <h4 className="font-weight-bold">Acompanhamentos</h4>
          <div className="form-group">
            <label htmlFor="segmento">Segmentos</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Ex.: Gostaria de tudo relacionado a Painéis, luminosos, faixas, displays, plaqueta patrimonial"
              rows={3}
              value={segmentosFollowups}
              onChange={(event) => setSegmentosFollowups(event.target.value)}
            />
          </div>
          <div className="d-flex justify-content-between col-md-12 p-0">
            <div className="left date-template">
              <label className="m-0">Estado</label>
            </div>
            <div className="float-right date-template">
              <button
                type="button"
                className="btn btn-sm btn-link pr-0"
                onClick={() => setStatesFollowups(dataFilter?.licitacao[1]?.estados?.values)}
              >
                Todos os estados
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <Select
                isMulti
                name="estado"
                options={States}
                value={statesFollowups || ''}
                closeMenuOnSelect={false}
                placeholder="Selecione um ou mais estados"
                classNamePrefix="select"
                className="basic-multi-select"
                onChange={(event) => setStatesFollowups([...event])}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Cidades</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Descreva as cidades"
              rows={3}
              value={citiesFollowups}
              onChange={(event) => setCitiesFollowups(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Palavras-chave</label>
            <textarea
              className="form-control"
              id="palavra_chave_followups"
              name="palavra_chave_followups"
              placeholder="Ex.: Gostaria de tudo relacionado a Painéis, luminosos, faixas, displays, plaqueta patrimonial"
              rows={3}
              value={palavraChaveFollowups}
              onChange={(event) => setPalavraChaveFollowups(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="segmento">Observações</label>
            <textarea
              className="form-control"
              id="segmento"
              name="segmento"
              placeholder="Escreva qualquer outra especificação para esse filtro"
              rows={3}
              value={obsFollowups}
              onChange={(event) => setObsFollowups(event.target.value)}
            />
          </div>
          <hr />
          <p>Obs.: Será enviada uma solicitação para nossos consultores editarem esse filtro</p>
          <hr />
          <div className="text-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>
                Api.post('/solicitation_edit_filter', {
                  title,
                  title_previous: dataFilter?.nome_filtro,
                  obsFollowups,
                  obsBidding,
                  users: usersFilter,
                  users_previous: dataFilter?.users
                    .filter(Boolean)
                    ?.map((users: any) => users.nome),
                  segmentosBidding,
                  segmentosBiddingPrevious: dataFilter?.licitacao?.[0]?.atividades?.values,
                  segmentosFollowups,
                  segmentosFollowupsPrevious: dataFilter?.acompanhamento?.[0]?.atividades?.values,
                  palavraChaveBidding,
                  palavraChaveBiddingPrevious: dataFilter?.licitacao?.[2]?.palavra_chave?.values,
                  palavraChaveFollowups,
                  palavraChaveFollowupsPrevious:
                    dataFilter?.acompanhamento?.[2]?.palavra_chave?.values,
                  morning,
                  afternoon,
                  night,
                  stateBidding,
                  StatesBiddingPrevious: dataFilter?.licitacao?.[1]?.estados?.values,
                  stateFollowups,
                  statesFollowupsPrevious: dataFilter?.acompanhamento?.[1]?.estados?.values,
                  citiesFollowups,
                  citiesBidding,
                  citiesBiddingPrevious: dataFilter?.licitacao[2]?.cidades?.values,
                  citiesFollowupsPrevious: dataFilter?.licitacao[2]?.acompanhamento?.values,
                }).then((response) => {
                  setLoadingEdition(true);
                  if (response.status === 200) {
                    setShowEditModal(false);
                  }
                })
              }
            >
              Solicitar edição do filtro
            </button>
            {loadingEdition && <SquareLoader customClass="delete-word" />}
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default EditFilterModal;
